/* global $ */
/* global gettext */

/**
 *
 */
(function (scope) {
  "use strict";

  /**
   * @constructor
   * @param {sculpteo.PrintController} controller
   * @param {Design} design
   */
  var PrintNotificationView = (scope.PrintNotificationView = function (
    controller,
    design
  ) {
    this.controller = controller;
    this.design = design;
    this.$parent = $(".PrintNotificationView");
    this.$el = $(".PrintNotificationView ul");

    this.delayNotification = 8500;

    this.$el.on(
      "click",
      'a[class^="toggle-view-"]',
      this.toggleSpecificView.bind(this)
    );

    this.last_message = null;
    this.timer_last_message = null;
  });

  /**
   * Shows an error
   * @public
   * @param {string} id
   */
  PrintNotificationView.prototype.error = function (id, autoHide, data) {
    this.render(id, "err", !!autoHide, data);
  };

  /**
   * Shows a warning
   * @public
   * @param {string} id
   */
  PrintNotificationView.prototype.warn = function (id, autoHide, data) {
    this.render(id, "warn", !!autoHide, data);
  };

  /**
   * Shows an info
   * @public
   * @param {string} id
   */
  PrintNotificationView.prototype.info = function (id, autoHide, data) {
    if (autoHide == undefined || autoHide == null) {
      autoHide = true;
    }
    this.render(id, "info", !!autoHide, data);
  };

  /**
   * toggle specific view on notification
   * ex: solidity check can be activate when clicking on "toggle solidity check" in the notification
   */
  PrintNotificationView.prototype.toggleSpecificView = function (e) {
    var currentClassString = $(e.currentTarget).attr("class");
    if (currentClassString == "toggle-view-solidity-check") {
      this.controller.views.toolbar.changeView(
        sculpteo.PrintToolbarView.VIEWS.SOLIDITY_CHECK
      );
    }
  };

  /**
   * Handle notification in HTML
   * @private
   * @param {string} id
   * @param {string} className corresponding to the notification level
   * @param {bool} True to automatically hide the notification
   * @param {string} data sup
   */
  PrintNotificationView.prototype.render = function (
    id,
    className,
    autoHide,
    data
  ) {
    var $li = $("li", this.$el);
    var message = "";
    if (data == undefined || data == null) {
      data = "";
    }

    // if the list is empty we reinitialize all_messages
    if ($li.length === 0) {
      this.all_messages = [];
    }

    // if the current message is in all_messages we don't show it.
    // Avoiding double or triple identical messages in a row
    if (this.all_messages.indexOf(id) != -1) {
      return;
    }

    // Add current message to all_messages
    this.all_messages.push(id);

    if (this.timer_last_message) {
      clearTimeout(this.timer_last_message);
      this.timer_last_message = null;
    }

    this.timer_last_message = window.setTimeout(
      function () {
        this.all_messages = [];
      }.bind(this),
      this.delayNotification
    );
    // Handling "key" messages (warnings codes & errors from princing API)
    if (Object.keys(sculpteo.messagesTranslations).indexOf(id) > -1) {
      message = sculpteo.messagesTranslations[id];
      message = message.replace("XXXX", data);
    } else {
      console.log("%c this is missing:", "color: red; font-weight: bold;");
      console.log(id);
      console.log("%c Should be:", "color: red; font-weight: bold;");
      console.log(data);
      message = gettext("An error occured");
    }

    //if this is an error and this error is one about solidity whe add a link + a text
    // the link trigger the view solidity check
    if (
      id == sculpteo.ERROR.SOLIDITY_WILL_BREAK ||
      id == sculpteo.ERROR.SOLIDITY_MAY_BREAK ||
      id == sculpteo.WARNING.SOLIDITY_MAY_BREAK
    ) {
      message +=
        "<br><a class='toggle-view-solidity-check'>" +
        gettext("Toggle Solidity Check") +
        "<span class='icon-solidity'></span></a>";
    }

    this.$parent.show();
    var $message = $("<li>")
      .html(message)
      .addClass(className)
      .addClass("notification-" + className)
      .toggleClass("auto-hide", !!autoHide);
    $message.appendTo(this.$el);

    if (autoHide) {
      setTimeout(
        function () {
          $message.remove();
          this.hideIfEmpty();
          this.controller.setLoading(false);
        }.bind(this),
        this.delayNotification
      );
    }
  };

  /**
   * Remove all displayed notifications
   * @public
   */
  PrintNotificationView.prototype.clear = function () {
    $("li:not(.auto-hide)", this.$el).remove();
    this.hideIfEmpty();
  };

  /**
   * Hide container if empty
   * @private
   */
  PrintNotificationView.prototype.hideIfEmpty = function () {
    if (!$("li", this.$el).length) {
      this.$parent.hide();
    }
  };
})((window.sculpteo = window.sculpteo || {}));
